import React, { useCallback } from 'react'
import BtnPrimary from 'components/generic/BtnPrimary'
import BtnSecondary from 'components/generic/BtnSecondary'
import Modal from 'react-modal'
import { Trans, useTranslation } from 'react-i18next'
import modalStyles from '../generic/modalWTN.module.scss'
import { useFormikContext } from 'formik'

interface Props {
  isOpen: boolean
  onClose: () => void
}

const ConfirmationModal = ({ isOpen, onClose }: Props) => {
  const { t } = useTranslation(['strCommonUI', 'strPsq'])
  const { submitForm } = useFormikContext()
  const handleSubmit = useCallback(() => {
    submitForm()
    onClose()
  }, [submitForm, onClose])

  return (
    <Modal
      closeTimeoutMS={500}
      isOpen={isOpen}
      className={modalStyles.modalWrapper}
      onRequestClose={onClose}
      portalClassName={'modal-wtn-portal'}
      appElement={document.getElementById('psq-public') as HTMLElement}
    >
      <div className={modalStyles.header}>{t('modalConfirm.heading', { ns: 'strPsq' })}</div>
      <div className={modalStyles.body}>
        <Trans ns='strPsq' i18nKey={'modalConfirm.infoText'}>
          You'll only be able to submit this form <b>ONCE</b>.<br></br>
          Please <b>confirm you're happy with the answers</b>.
        </Trans>
      </div>
      <div className={`${modalStyles.btns} ${modalStyles.btnsPSQ}`}>
        <BtnSecondary onClick={onClose} size={'medium'}>
          {t('button.cancel', { ns: 'strCommonUI' })}
        </BtnSecondary>
        <BtnPrimary size={'medium'} type='submit' onClick={handleSubmit}>
          {t('button.confirm', { ns: 'strCommonUI' })}
        </BtnPrimary>
      </div>
    </Modal>
  )
}

export default ConfirmationModal
